export function renderUserDashboard() {
  return window.renderDashboard?.();
}
